import { Injectable } from '@angular/core';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import { ActiveCartService, CartActions } from '@spartacus/cart/base/core';
import { CartAddEntrySuccessEvent } from '@spartacus/cart/base/root';
import { createFrom, EventService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { FbqGgCartAddEntrySuccessEvent } from './fbq-gg-cart-add-entry-success-event';

@Injectable({
  providedIn: 'root',
})
export class FbqGgCartAddEntrySuccessEventBuilder {
  constructor(
    private eventService: EventService,
    private activeCartService: ActiveCartService,
    private actionsSubject: ActionsSubject
  ) {
    const fbqGgCartAddEntrySuccessEventSource = this.eventService.get(CartAddEntrySuccessEvent).pipe(
      switchMap(() =>
        this.getAction(CartActions.CART_ADD_ENTRY_SUCCESS).pipe(
          take(1),
          map(() =>
            createFrom(FbqGgCartAddEntrySuccessEvent, {
              event: 'AddToCart',
            })
          )
        )
      )
    );

    eventService.register(FbqGgCartAddEntrySuccessEvent, fbqGgCartAddEntrySuccessEventSource);
  }

  protected getAction(actionType: string | string[]): Observable<{ type: string; payload?: any }> {
    return this.actionsSubject.pipe(ofType(...([] as string[]).concat(actionType)));
  }
}
